module.exports = __webpack_public_path__ + "static/media/eionet.33f37fbf.svg";